module.exports = __webpack_public_path__ + "img/follow_bg_01.1220846a.png";